import { Component, OnInit } from '@angular/core';
import { translate } from '@jsverse/transloco';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {

  title = translate('NOTIFICATION.NOTIFICATIONS');
  constructor() { }

  ngOnInit(): void {
  }

}
